// extracted by mini-css-extract-plugin
export default {"form_container":"style_form_container__ZOfPc"};